import ExternalController from "./external-controller";
import { IReactConfiguration, IUploadYourLabel } from "../../typings";
import IEventController from "./ievent-controller";

export default class EventController implements IEventController {
  conf: IReactConfiguration;
  outsideClass?: IUploadYourLabel;
  constructor(conf: IReactConfiguration, outsideClass: IUploadYourLabel) {
    this.conf = conf;
    this.outsideClass = outsideClass;
  }
  sendLoadedEvent(external: ExternalController): void {
    this.outsideClass._afterConfiguratorLoaded(external);
  }

  static getSaveEventName(name: Array<string>): string {
    return "save_option_value_" + name[name.length - 1];
  }

  newEvent<T>(
    typeArg: string,
    eventInitDict?: CustomEventInit<T>,
  ): CustomEvent<T> {
    return new CustomEvent<T>(typeArg, eventInitDict);
  }

  sendSaveEvent(eventName: string, name: Array<string>): void {
    const event: CustomEvent = this.newEvent(eventName, {
      detail: JSON.stringify(name),
    });
    this.dispatchEvent(event);
  }

  addEventListener(eventName: string, listener: (event: any) => any): void {
    document
      .querySelector(this.conf.target)
      .addEventListener(eventName, listener);
  }

  removeEventListener(eventName: string, listener: (event: any) => void): void {
    document
      .querySelector(this.conf.target)
      .removeEventListener(eventName, listener);
  }

  dispatchEvent(event: CustomEvent | any): void {
    document.body.querySelector(this.conf.target).dispatchEvent(event);
  }
}
